import styled from "styled-components";

export const CardContainer = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 12px 16px;
  width: 100%;
  margin-bottom: 8px;
`;

// Top Section: Logo + Title (Left) | Price + CTA (Right)
export const TopSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 45px;
  margin-bottom: 12px;
`;

export const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
`;

export const LogoSection = styled.div`
  flex-shrink: 0;

  img {
    width: 100%;
  }
`;

export const TitleSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const PlanTitle = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
`;

export const CompanyName = styled.span`
  font-size: 14px;
  color: #666;
`;

// Bottom Section: Benefits (Left) | Actions (Right)
export const BottomSection = styled.div`
  display: flex;
  padding: 12px;
  align-items: center;
  gap: 48px;
  border-radius: 8px;
  background: #f2f2f2;
  justify-content: space-between;
`;

export const ActionsSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
`;

export const DownloadSection = styled.div`
  cursor: pointer;
  padding: 0 8px;
  border-radius: 4px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #f5f5f5;
  }
`;

export const PriceContainer = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
  justify-content: flex-end;
`;

export const StrikethroughPrice = styled.span`
  color: #000;
  font-size: 14px;
  text-decoration: line-through;
`;

export const CurrentPrice = styled.span`
  color: #000;
  font-size: 16px;
  font-weight: 900;
`;

export const PerPersonText = styled.span`
  color: #4a4a4a;
  font-size: 12px;
  margin-left: 4px;
`;

export const DiscountWrapper = styled.div`
  display: flex;
  width: 186px;
  padding: 4px 4px 4px 20px;
  flex-direction: column;
  align-items: flex-end;
  border-radius: 12px;
  background: linear-gradient(289deg, #fff6e3 0.59%, #fff 99.84%);
  margin-top: 0;
  margin-left: auto;
`;

export const DiscountText = styled.div`
  color: #000;
  font-size: 12px;
  font-weight: 700;
`;

export const BuyButtonSection = styled.button`
  background: linear-gradient(92deg, #53b2fe 0%, #065af3 100%);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 16px;
  cursor: pointer;
  font-weight: 600;
  font-size: 12px;
  min-width: 120px;
  transition: all 0.2s ease;
  text-transform: uppercase;

  &:hover {
    background: linear-gradient(92deg, #4a9fe8 0%, #0548db 100%);
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(83, 178, 254, 0.3);
  }

  &:active {
    background: linear-gradient(92deg, #3b8dd4 0%, #0440c3 100%);
    transform: translateY(0);
  }
`;

export const BenefitsSection = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1;
  height: 16px;

  @media (max-width: 767px) {
    html:not([data-device="tablet"]) & {
      flex-direction: column;
      gap: 16px;
    }
  }
`;

export const BenefitItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;

  @media (max-width: 767px) {
    html:not([data-device="tablet"]) & {
      flex: none;
    }
  }
`;

export const BenefitIcon = styled.span`
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 20px;
    height: 20px;
    object-fit: contain;
  }
`;

export const BenefitText = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  gap: 8px;

  > span:first-child {
    color: #000;
    font-size: 12px;
    line-height: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
  }

  > span:last-child {
    color: #000;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    flex-shrink: 0;
    white-space: nowrap;
  }
`;

export const MoreBenefitsSection = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: #008cff;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  text-align: right;
  transition: all 0.2s ease;

  &:hover {
    color: #0070cc;
  }
`;

export const DownloadIcon = styled.span`
  color: #757575;
  transition: color 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 17px;

  svg {
    width: 100%;
    height: 100%;
  }

  ${DownloadSection}:hover & {
    color: #3367d6;
  }
`;
